import { NOTIFICATIONS_STATUSES } from 'src/constants';
import { Notification } from 'src/store/notifications/types';
import { API } from 'src/utils/AmplifyApiUtils';

export default class NotificationsClient {
  /**
   * After a channel is selected, this API method
   * is called to mark channel's unread notifications are read.
   * @param unreadNotifications
   * @param notificationEntity
   */
  static markFileNotificationAsRead(
    unreadNotifications: Array<Notification>,
    notificationEntity: string,
  ) {
    return API.put('AppAPI', `/entities/${notificationEntity}`, {
      queryStringParameters: {
        updateState: NOTIFICATIONS_STATUSES.READ,
      },
      body: {
        data: unreadNotifications,
      },
    });
  }
}
